<template>
    <div class="monitoring tmp-block no-line">
        <div class="title-contents">
            <img src="@/assets/icons/online.svg" alt="">
            <h2>Мониторинг</h2>
        </div>
        <div class="online">
            <h4>Сейчас {{getPlayerOnlineVerb(online)}}</h4>
            <div class="players">
                <span>{{online}} {{getPlayerOnlineNoun(online)}}</span>
                <progress_circle :progress="online / numberOfSlots" :size="28" :stokeWidth="7"/>
            </div>
        </div>
        <div class="line"></div>
        <p class="caps">Для всех версий</p>
        <h1 class="server" v-html="markOutServerColon"></h1>
        <div class="nav">
            <a class="w-100" href="minecraft://?addExternalServer=VineMine|bp.vinemine.net:19132" target="_blank">
                <large_button color="green">ДОБАВИТЬ В ИГРУ</large_button>
            </a>
            <large_button class="copy-server" :data-clipboard-text="server" color="purple">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#copy_filter0_d)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 6C5.44772 6 5 6.44772 5 7V19C5 19.5523 5.44772 20 6 20H20C20.5523 20 21 19.5523 21 19V7C21 6.44772 20.5523 6 20 6H6ZM7 18V8H19V18H7Z" fill="url(#copy_paint0_linear)"/>
                        <path d="M14 24H25V14H21V12H26C26.5523 12 27 12.4477 27 13V25C27 25.5523 26.5523 26 26 26H13C12.4477 26 12 25.5523 12 25V20H14V24Z" fill="url(#copy_paint1_linear)"/>
                    </g>
                    <defs>
                        <filter id="copy_filter0_d" x="1" y="4" width="30" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                            <feOffset dy="2"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0.345098 0 0 0 0 0.219608 0 0 0 0 0.858824 0 0 0 1 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                        </filter>
                        <linearGradient id="copy_paint0_linear" x1="16" y1="6" x2="16" y2="26" gradientUnits="userSpaceOnUse">
                            <stop offset="0.480263" stop-color="white"/>
                            <stop offset="1" stop-color="white" stop-opacity="0.48"/>
                        </linearGradient>
                        <linearGradient id="copy_paint1_linear" x1="16" y1="6" x2="16" y2="26" gradientUnits="userSpaceOnUse">
                            <stop offset="0.480263" stop-color="white"/>
                            <stop offset="1" stop-color="white" stop-opacity="0.48"/>
                        </linearGradient>
                    </defs>
                </svg>
            </large_button>
        </div>
    </div>
</template>

<script>
    import large_button from '@/elements/large_button.vue'
    import progress_circle from '@/elements/progress_circle.vue'
    import proschet from 'proschet';


    import ClipBoard from 'clipboard';
    import {mapActions, mapMutations, mapState} from "vuex";

    const getPlayerOnlineNoun = amount => proschet(['игрок', 'игрока', 'игроков'])(amount);
    const getPlayerOnlineVerb = amount => proschet(['играет', 'играют', 'играют'])(amount);

    export default {
        name: "monitoring",
        components: {
            large_button,
            progress_circle,
        },
        data: () => ({
            server: "pe.VineMine.net:19132",
            notificationTimeout: false,
            timeout: false,

            numberOfSlots: 1000,
            clipboard: false,


        }),
        created() {
            this.getOnline();
        },
        mounted() {
            this.clipboard = new ClipBoard('.monitoring .copy-server');
            this.clipboard.on('success', () => {
                console.log('success');
                if (this.notificationTimeout) return;
                this.startTimeout();
                this.putNotificationDefault('Адрес скопирован');
            });
            this.clipboard.on('error', () => {
                if (this.notificationTimeout) return;
                alert('Error')
            });
        },
        destroyed() {
            if(this.clipboard) this.clipboard.destroy();
        },
        computed: {
            markOutServerColon() {
                return this.server.replace(':', '<span class="fade">:</span>')
            },
            ...mapState('main', ['online'])
        },
        methods: {
            startTimeout() {
                this.notificationTimeout = true;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.notificationTimeout = false;
                }, 4000)
            },
            getPlayerOnlineNoun(amount){
                return getPlayerOnlineNoun(amount);
            },
            getPlayerOnlineVerb(amount){
                return getPlayerOnlineVerb(amount);
            },
            ...mapActions('main', ['getOnline']),
            ...mapMutations('notifications', ['putNotificationDefault'])
        }
    }
</script>

<style lang="scss">
    .monitoring {
        padding: 32px 32px 44px !important;

        .title-contents {
            img {
                margin-right: 12px;
            }
        }

        .online {
            & > * {
                font-weight: 800 !important;
                font-size: 28px;
                line-height: 36px;
            }

            h4 {
                color: white;
                margin-bottom: 2px;
            }

            .players {
                display: flex;
                align-items: center;

                span {
                    color: $blue;
                    margin-right: 10px;
                }

                .progress-circle {
                    svg {
                        .progress-indicator {
                            stroke: $blue;
                        }

                        .static-circle {
                            stroke: $bg_line;
                        }
                    }
                }
            }
        }

        .line {
            margin-top: 20px;
            margin-bottom: 24px;
        }

        h1.server {
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .nav {
            display: flex;

            .copy-server {
                flex-shrink: 0;
                width: 56px;
                margin-left: 8px;
            }
        }

        @include mobile {
            padding: 32px 24px 48px !important;

            background-color: $bg_light_plus !important;
            .online {
                & > * {
                    font-size: 32px;
                    line-height: 40px;
                }
            }
            .line{
                width: 50%;
            }
        }
    }
</style>
